import type { RefObject } from 'react'

import { useHeroScroll } from './use-hero-scroll'
import { useMarquee } from './use-marquee'
import { useMouseParallax } from './use-mouse-parallax'
import { usePageLoad } from './use-page-load'
import { useParallax } from './use-parallax'
import { useScrollReveal } from './use-scroll-reveal'
import { useSpin } from './use-spin'

/**
 * Wires every global, class/data-driven animation for a page in one place.
 * Called once from the shared Layout, scoped to the page root so it re-runs on
 * each route change (matching the original per-page Webflow load behaviour).
 * Component-local interactions (nav dropdown, mobile menu, accordions, hovers)
 * live with their own components.
 */
export const useSiteAnimations = (scope: RefObject<HTMLElement | null>): void => {
    usePageLoad(scope)
    useHeroScroll(scope)
    useScrollReveal(scope)
    useParallax(scope)
    useMarquee(scope)
    useSpin(scope)
    useMouseParallax(scope)
}
